export var BannerActionTypes;
(function (BannerActionTypes) {
    BannerActionTypes["FETCH_BANNER_ATTEMPT"] = "FETCH_BANNER_ATTEMPT";
    BannerActionTypes["FETCH_BANNER_SUCCESS"] = "FETCH_BANNER_SUCCESS";
    BannerActionTypes["FETCH_BANNER_FAILURE"] = "FETCH_BANNER_FAILURE";
})(BannerActionTypes || (BannerActionTypes = {}));
